import { formatMoneyWithCurrency } from 'src/utils/formatter'
import './styles.scss'
import { findHighestAndLowestAmount } from '../functions'

export const DropdownToPayResume = ({ data, source, companyId, isToPay }) => {
  
  const result = findHighestAndLowestAmount(source)

  return (
    <>
      <div className="tw-px-7 tw-py-5 tw-flex tw-flex-col tw-gap-6">
        <div className='tw-flex tw-justify-between tw-items-center'>
          <p className="tw-font-semibold tw-text-lg tw-text-black !tw-p-0 !tw-m-0">Detalles de cuentas por {isToPay ? 'cobrar':'pagar'}</p>
        </div>
        <div className="tw-flex tw-gap-6">
          <div className="tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-flex-col tw-gap-6">
              <div className="tw-w-[480px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-[#1D7EE3] tw-text-white tw-flex tw-flex-col tw-gap-1">
                <p className="tw-font-normal tw-text-base !tw-p-0 !tw-m-0">Monto total al día</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(data.valid)}</p>
              </div>
              <div className="tw-w-[480px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-yellow-500 tw-text-white tw-flex tw-flex-col tw-gap-1">
                <p className="tw-font-normal tw-text-base !tw-p-0 !tw-m-0">Monto total atrasado</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(data.totalDebt)}</p>
              </div>
              <div className="tw-w-[480px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-gray-100 tw-flex tw-flex-col tw-gap-1 tw-border-solid tw-border-[1px] tw-border-gray-300">
                <p className="tw-font-normal tw-text-base !tw-p-0 !tw-m-0 tw-text-gray-600">Proveedor con mayor monto por {isToPay ? 'cobrar':'pagar'}</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0 tw-text-black">{result?.mayorDeudor?.nombre}</p>
              </div>
              <div className="tw-w-[480px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-gray-100 tw-flex tw-flex-col tw-gap-1 tw-border-solid tw-border-[1px] tw-border-gray-300">
                <p className="tw-font-normal tw-text-base !tw-p-0 !tw-m-0 tw-text-gray-600">Proveedor con menor monto por {isToPay ? 'cobrar':'pagar'}</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0 tw-text-black">{result?.menorDeudor?.nombre}</p>
              </div>
            </div>
          </div>
          <div className="tw-w-full tw-border-solid tw-border-[1px] tw-border-gray-300 tw-rounded-md">
            <div className="tw-w-full tw-bg-gray-200 tw-h-[40px] borderBgray tw-flex tw-justify-between tw-px-4 tw-items-center">
              <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Razón Social</p>
              <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Monto Bruto</p>
            </div>
            <div className='tw-max-h-[320px] tw-overflow-y-auto'>
              {source?.map((item, index) => (
                <div key={index} className={`tw-w-full tw-h-[40px] ${index !== source.length - 1 ? 'borderBgray' : ''} tw-flex tw-px-4 tw-items-center tw-justify-between`}>
                  <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm tw-uppercase'>{item.name}</p>
                  <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm'>{formatMoneyWithCurrency(item.valid + item.expired30 + item.expired60 + item.expired90 + item.expiredOlder)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}